import React from 'react';

const AuthenticationContext = React.createContext({user: {}});

export default AuthenticationContext